import WebService from '@kega/webservice';

import storeErrorHandler from '../lib/errors/storeErrorHandler';

const OccClient = (config, { baseSiteId = '' }) => {
    if (!config) {
        throw new Error('OCC config not found!');
    }

    const client = new WebService({
        url: `${config.url}/occ/v2/${baseSiteId}`,
    });

    client.onError(storeErrorHandler);

    return client;
};

export default OccClient;
